export default {
  gw: {
    news: {
      title: "Guide & News",
      strategyTab: "Official Guide",
      announcementTab: "Announcement",
      prevPage: "Prev",
      nextPage: "Next",
      returnBtn: "Back",
      returnList: "Back List",
      prevArticle: "Prev",
      nextArticle: "Next",
      noContent: "No Content",
      backToIndex: "Back to Home",
      more: "More",
    },
  },
  yy: {
    title: "CONQUEST OF NINE KINGDOMS",
    slogan: "A New Era of Real-Time Three Kingdoms SLG",
    preRegister: "Pre-Register Now",
    giftTitle: "Luoyang Prize Tournament",
    milestoneTitle: "Follow&Claim Rewards",
    featureTitle: "Visit Official Site",
    comingSoon: "Coming Soon",
  },
  foot: {
    Notice: "Important Notes",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    EmailText: "E-mail：",
    copy: "Copy successful",
    version: "Copyright© 2026 RASTAR GAMES (HK) CO., Ltd. All Rights Reserved",
  },
  alliance: {
    language_1: "Please join/create an alliance first",
    language_2: "Not enough draws. Complete tasks to earn more.",
    language_3: "Please log in first",
    language_4: "Coming Soon",
    language_5: "Copy successful",
    language_6: "Copy fails, please try to copy manually",
    language_7: "Link copied! Invite your friends to join your Alliance!",
    language_8:
      "Pre-alliance event ended. Tap [Lucky Draw] below > [My Rewards] to claim your gift code.",
    footer: {
      language_1: "Rules",
      language_2: "Privacy Policy",
      language_3: "VIP Terms",
    },
    home: {
      language_1_1: "Welcome, [",
      language_1_2: "]",
      language_2: "Alliance Members: ",
      language_3: "Alliance Points: ",
      language_4: "Active Alliances: ",
      language_5: "Enter Prep Alliance ID or Name",
      // language_6: "ID ",
      language_7: "Leader",
      language_8: "Members",
      language_9: "Motto",
      language_10: "[Login]",
      create: {
        language_1: "Please enter (max 30 characters)",
        language_2: "Please enter (max 30 characters)",
        language_3: "Please enter (max 100 characters)",
        language_4: "Please enter the group link",
      },
    },
    luckyDraw: {
      language_1: "Draws Remaining: ",
    },
    quests: {
      language_1: " Points",
      language_2: " Draws",
      language_3: "First daily page share",
      language_4: "Invite friends",
      language_5: "Pre-register on store",
      language_6: "Follow official FB",
      language_7: "Join official Discord",
    },
    confirmDialog: {
      language_1:
        "Each account can only create/join an alliance ONCE. This cannot be undone. Confirm?",
    },
    successDialog: {
      language_1: "You have successfully joined the alliance.",
      language_2: "Alliance created successfully",
      language_3:
        "Complete alliance tasks to earn points and draw chances for great rewards!",
    },
    myRewardsDialog: {
      language_1: " Members",
      language_2: "Recruitment Token x",
    },
    preSelectedServerDialog: {
      language_1: "Server",
      language_2:
        "※ Be sure to log in to the game using the same RASTAR GAMES account you used for the Alliance Pre-Build event. Create your character with this account within 6 hours after Open Beta launch, and you will enter your selected server directly — no server status restrictions apply. Each server is limited to 3 Alliance Pre-Build reservations on a first-come, first-served basis.",
    },
    receivedDialog: {
      language_1:
        "*Rewards will be distributed as redemption codes on this event page after Open Beta launch. You must log in to the event page with your RASTAR GAMES account to claim them.",
    },
    speedRankingDialog: {
      language_1: "Event Servers: ",
      language_2: "Rank",
      language_3: "Server",
      language_4: "Alliance",
      language_5: "Time",
      language_6: "Last updated: ",
      language_7: " min ",
      language_8: " sec",
    },
  },
};
